import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';

import type {GetDigestConfiguration_digestConfiguration_subscription as DigestSubscription} from 'nutshell-graphql-types';

import {useUpdateDigestSubscription} from './graphql/hooks/use-update-digest-subscription';
import {MorningJoltConfig} from './morning-jolt-config';
import {TeamReportConfig} from './team-report-config';

type Props = {
    morningJoltSubscription: DigestSubscription | null | undefined;
    isLoadingMorningJolt: boolean;
    teamReportSubscription: DigestSubscription | null | undefined;
    isLoadingTeamReport: boolean;
    morningJoltNextSendDate: string | null | undefined;
    teamReportNextSendDate: string | null | undefined;
    isAdmin: boolean;
};

export function DigestsConfig(props: Props) {
    const {updateDigestSubscription} = useUpdateDigestSubscription();

    const morningJoltFrequency = props.morningJoltSubscription
        ? props.morningJoltSubscription.frequency
        : 'WEEKLY';

    const teamReportFrequency = props.teamReportSubscription
        ? props.teamReportSubscription.frequency
        : 'WEEKLY';

    return (
        <Stack spacing={16}>
            <MorningJoltConfig
                updateDigestSubscription={updateDigestSubscription}
                isSubscribedToMorningJolt={Boolean(
                    props.morningJoltSubscription && props.morningJoltSubscription.isActive
                )}
                morningJoltFrequency={morningJoltFrequency}
                isLoadingMorningJolt={props.isLoadingMorningJolt}
                subscription={props.morningJoltSubscription}
                nextSendDate={props.morningJoltNextSendDate}
            />
            {props.isAdmin && (
                <TeamReportConfig
                    updateDigestSubscription={updateDigestSubscription}
                    isSubscribedToTeamReport={Boolean(
                        props.teamReportSubscription && props.teamReportSubscription.isActive
                    )}
                    teamReportFrequency={teamReportFrequency}
                    isLoadingTeamReport={props.isLoadingTeamReport}
                    subscription={props.teamReportSubscription}
                    nextSendDate={props.teamReportNextSendDate}
                />
            )}
        </Stack>
    );
}
